module.exports = __webpack_public_path__ + "img/9788936456092.0e09bc57.jpg";